import { useMemo } from "react"
import { usePhones } from "./usePhones"

export function usePrimaryPhone() {
  const phones = usePhones()

  const primaryPhone = useMemo(
    () => phones.data?.find(
      (phone) => phone.is_primary && phone.deleted_at === null,
    ),
    [phones.data],
  )

  return primaryPhone
}
